
import Dinero from 'dinero.js'
import json_data from '../../../data.json'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconCheck from '@/components/icons/check.vue'
import IconBase from '@/components/IconBase.vue'

import IconForwardBack from '@/components/icons/arrowForward.vue'
import IconPencil from '@/components/icons/pencil.vue'
import IconCustomerSupport from '@/components/icons/customerSupport.vue'

import Globals from '@/assets/scripts/global-functions.js'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'
import PremiumToggle from '@/components/forms/PremiumToggle.vue'
import PremiumData from '@/components/forms/PremiumData.vue'
import PremiumSideBar from '@/components/forms/PremiumSideBar.vue'

import PremiumBreakdown from '@/components/forms/PremiumBreakdown.vue'
import PremiumPoliceChecked from '@/components/forms/PremiumPoliceChecked.vue'

export default {
    name: 'FinalQuote',
    props: ['EditStatus'],
    components: {
        IconArrowBack,
        IconBase,
        IconForwardBack,
        IconPencil,
        IconCheck,
        IconCustomerSupport,
        Globals,
        BackButton,
        NextButton,
        PremiumToggle,
        PremiumData,
        PremiumSideBar,
        PremiumBreakdown,
        PremiumPoliceChecked,
        
    },
    data: () => ({
        declarations: false,
    }),
    watch: {
        // EditStatus: function(newVal, oldVal) {
        //     if (newVal == true) {
        //         var x = document.getElementById("sidebar_main_container");
        //         x.classList.add("full_width_container");
        //         x.classList.add("block")
        //     } else {
        //         var x = document.getElementById("sidebar_main_container");
        //         x.classList.remove("full_width_container");
        //         x.classList.remove("block");
        //     }
        // }
    },
    mounted() {
        //delete
        if(this.$parent.Role == undefined){
            this.$parent.Role = 'educator';
        }
        this.$parent.EducatorInsuranceProcess = Globals.CreateLocalData(this.$parent.Role);
        this.$refs.toggle.ToggleSelected('yearly');
        this.$parent.CheckWindowPathName();
        

        //Add to PO
        //this.AddToDB();

        this.$parent.$parent.CurrentProcess = "EducatorInsuranceProcess";

       
        
    },
    methods: {
        declarations(params){
            this.declarations(params);
        },

        AdditionalCoverCost(_total_amount){
            let additional_cover_ = this.datas.educators.packages.additional_cover;
            let ac = this.$parent.EducatorInsuranceProcess.additional_cover;
            let additional_cover_cost_ = 0;
            if(ac.length > 1){
                let  additional_cover_filter = additional_cover_.filter(ac => ac.name.indexOf('Both') >= 0);
                additional_cover_cost_ = additional_cover_filter[0].cost;
            }else if(ac.length == 1){
                let  additional_cover_filter = additional_cover_.filter(ac => ac.name.indexOf(this.additional_cover) >= 0);
                additional_cover_cost_ = additional_cover_filter[0].cost;
            }else{
                additional_cover_cost_ = 0;
            }
            this.additional_cover_cost = Dinero({
                amount: parseInt(additional_cover_cost_),
                currency: 'AUD',
                precision: 2
            }).toUnit();

            return additional_cover_cost_;
        },
        Edit() {
            this.$refs.fullwidth_sidebar.fullwidth_sidebar();
        },
        Next() {
            this.$parent.EditStatus = false;
            this.$parent.EducatorNextStep(-1,"EducatorTermsAndConditions"); 
        },

    }
} 